//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
// chrome-nav imports
import { ChromeNavGeneric } from "./ChromeNavGeneric";
// other internals
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { SidebarDialog } from "@clockwise/web-commons/src/components/sidebar-dialog";
// util
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";
// state
import { updateSchedulingSessionId } from "#webapp/src/state/actions/feed-scheduler.actions";
// material-ui
import { Button } from "@clockwise/design-system";
import { DialogActions, DialogContent } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////

export const ChromeNavEventScheduler = () => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = React.useState(false);

  const schedulingSessionId = useSelector(
    (state: IReduxState) => state.feedScheduler.schedulingSessionId,
  );
  const isChromeExtension = useSelector((state: IReduxState) => state.webExtension.isWebExtension);
  const dispatch = useDispatch();

  const goHome = () => {
    track(TrackingEvents.SCHEDULING.EVENT_SCHEDULER_LEAVE, {
      schedulingSessionId: schedulingSessionId,
    }); // analytics
    dispatch(updateSchedulingSessionId(""));

    setConfirmationDialogOpen(false);
  };

  const onBack = () => {
    return goHome();
  };

  return (
    <div>
      <ChromeNavGeneric label="New meeting" onBack={onBack} settings feedback />
      {confirmationDialogOpen && (
        <SidebarDialog
          open={confirmationDialogOpen}
          onClose={() => setConfirmationDialogOpen(false)}
          isChromeExtension={isChromeExtension}
        >
          <DialogContent>
            <div className="cw-heading-base cw-mb-2">Discard unsaved changes?</div>
          </DialogContent>
          <DialogActions>
            <Button variant="text" onClick={goHome} sentiment="positive">
              Discard
            </Button>
            <Button variant="text" onClick={() => setConfirmationDialogOpen(false)}>
              Cancel
            </Button>
          </DialogActions>
        </SidebarDialog>
      )}
    </div>
  );
};
